import { useEffect, useState } from "react";
import { useApiClient } from "../../../../shared/hooks";


function getDataForChart(data: any, label: string) {
  if (!data) {
    return null;
  }
  const sortedLabels = Object.keys(data).sort();
  return{
    labels: sortedLabels,
    datasets: [
      {
        label: `Daily Chat ${label}`,
        data: sortedLabels.map(label => data[label]),
        fill: false,
        backgroundColor: '#1f77b4',
        borderColor: '#1f77b4',
        pointRadius: 1,
        borderWidth: 2,
      },
    ],
  }

}

function useLineOfDailyChat(startDate: string, endDate?: string) {
  const apiClient = useApiClient();

  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [chatData, setChatData] = useState<any>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        setIsError(false);
        const data = await apiClient.getChatAnalyticsData(startDate, endDate);
        console.log('got response for chat data', data);
        setChatData(data);
      } catch (error) {
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [startDate, endDate]);

  if (!chatData) {
    return {
      group: null,
      plan: null,
      private: null,
      isLoading,
      isError,
    };
  }

  

  return {
    group: getDataForChart(chatData.group, 'Group'),
    plan: getDataForChart(chatData.plan, 'Plan'),
    private: getDataForChart(chatData.private, 'Private'),
    isLoading,
    isError,
  };
}

export default useLineOfDailyChat;
